export default __webpack_public_path__ + "static/media/Espa.f3820e1b.woff";